import 'objectFitPolyfill';
import 'focus-visible';

import './features/detect';
import './features/no-transition-on-resize';
import './features/inner-height-variable';
import './features/in-view';

import './views/menu';
import './views/footer';

import './woocommerce/cart';
import './woocommerce/expandable-list';
import './woocommerce/swiper';
import './woocommerce/tab-menu';
import './woocommerce/product-archive';
import './woocommerce/single-product';
import './woocommerce/selected-products';
import './woocommerce/my-account';

import './view-initalizer';
